import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { clearEmptyProperties } from '@core/utils/filters-utils';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';
import english from '../i18n/en.json';
import spanish from '../i18n/es.json';
import portuguese from '../i18n/pt.json';
var FilterUsersComponent = /** @class */ (function () {
    function FilterUsersComponent(formBuilder, fuseTranslationLoaderService) {
        this.formBuilder = formBuilder;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.filterChanged = new BehaviorSubject({ archived: false });
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    FilterUsersComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.filtersForm = this.formBuilder.group({
                    name: null,
                    email: null,
                    type: null,
                    groupId: null,
                    locationId: null,
                    archived: false,
                });
                this.filtersForm.valueChanges.pipe(debounceTime(500), tap(function () {
                    var filters = clearEmptyProperties({
                        name_contains: _this.filtersForm.value.name,
                        email_contains: _this.filtersForm.value.email,
                        type_in: _this.filtersForm.value.type,
                        group_id: _this.filtersForm.value.groupId,
                        location_id: _this.filtersForm.value.locationId,
                        archived: _this.filtersForm.value.archived
                    });
                    _this.filterChanged.next(filters);
                })).subscribe();
                return [2 /*return*/];
            });
        });
    };
    FilterUsersComponent.prototype.clearFilters = function () {
        this.filtersForm.patchValue({
            name: null,
            email: null,
            type: null,
            groupId: null,
            locationId: null,
            archived: false
        });
    };
    return FilterUsersComponent;
}());
export { FilterUsersComponent };
